import React, { FC } from "react";
import { convertToRelativeUrl } from "../../../../utils";
import { Separator } from "../../../atoms/Separator";
import { ChalleningSituationHomeCard } from "../../../molecules/ChallengingSituationHomeCard";
import { useChallengingSitationCardSize } from "../../../molecules/ChallengingSituationHomeCard/utils";
import { useCardCarousel } from "../../Carousel";
import { CarouselSection } from "../../CarouselSection";

type Props = {
    moreInformationCards: {
        title: string;
        href: string;
    }[];
};

export const MoreInformation: FC<Props> = props => {
    const { Carousel, scrollLeft, scrollRight, canScroll } = useCardCarousel(
        props.moreInformationCards.length,
        useChallengingSitationCardSize,
    );

    if (props.moreInformationCards.length === 0) {
        return null;
    }

    return (
        <>
            <CarouselSection
                title="Find more information on these pages on Headstart"
                carousel={{
                    content: (
                        <Carousel>
                            {props.moreInformationCards.map(card => (
                                <ChalleningSituationHomeCard
                                    appearance="mid"
                                    key={card.href}
                                    title={card.title}
                                    to={convertToRelativeUrl(card.href)}
                                />
                            ))}
                        </Carousel>
                    ),
                    onScrollLeft: scrollLeft,
                    onScrollRight: scrollRight,
                    canScroll,
                    displayControl: true
                }}
            />
            <Separator />
        </>
    );
};
